/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'components/Gallery/Gallery';
import './ImageGallery.scss';

/**
 * This is the ImageGallery component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function ImageGallery({ heading, ...props }) {
  function renderHeading() {
    if (!heading) return null;

    return <h2>{heading}</h2>;
  }

  return (
    <div className="block image-gallery" appear="true">
      {renderHeading()}
      <Gallery heading={heading} {...props} />
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
ImageGallery.propTypes = {
  heading: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
ImageGallery.defaultProps = {
  heading: '',
};

export default ImageGallery;
